// [マイページ] お気に入り商品
import Image from "components/common/images/Image";
import { FavoriteItemModel } from "models";
import React from "react";
import { Link } from "react-router-dom";
import { Utils } from "utils";

type PROPS = {
  items?: FavoriteItemModel[] | null;
};

const FavoriteItems: React.FC<PROPS> = (props) => {
  if (!props.items || props.items.length === 0) {
    return (
      <div className="p-4">
        <div className="flex justify-between border-b border-b-black p-1">
          <div className="font-bold">お気に入り商品</div>
        </div>
        <div className="mt-4 h-40"></div>
      </div>
    );
  }
  return (
    <div className="mt-4 p-4">
      <div className="flex justify-between border-b border-b-black p-1">
        <div className="font-bold">お気に入り商品</div>
        <Link to="/favorite-item/" className="text-jhk-blue hover:underline">
          ＞ お気に入り商品一覧を見る
        </Link>
      </div>
      <div className="mt-4 w-full flex justify-start">
        {props.items.map((item, index) => {
          if (item.favorite_item_cd === "") {
            return <div key={index} className="flex-1"></div>;
          }
          return (
            <Link
              key={index}
              className="flex-1 min-w-0"
              to={`/item-detail/${item.favorite_item_cd}/`}
            >
              <div className="p-2 hover:bg-gray-100">
                <Image
                  data={item.item_main_image}
                  width="100%"
                  height={`calc(calc(98vw - 20rem) / ${props.items?.length})`}
                  default="item.png"
                />
                <div className="whitespace-nowrap overflow-x-hidden text-ellipsis">
                  {item.item_name}
                </div>
                <div className="font-bold">
                  {item.is_discretionary_price ? (
                    <span className="text-2xl">-</span>
                  ) : (
                    <>
                      <span className="text-2xl">
                        {Utils.addComma(item.sale_price)}
                      </span>
                      円(税抜)
                    </>
                  )}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default FavoriteItems;
